interface NavbarDescriptor
{
	tag: string;
	isFluid: boolean;
	classes: string[];
	brand: HTMLElement;
}

interface NavbarContentDescriptor
{
	content: HTMLElement;
}

interface MenuPointDescriptor
{
		href: string;
		title: string;
		content: HTMLElement;
}

class Navbar
{
	private element: JQuery;
	private tempDiv: JQuery;
	private tempUl: JQuery;
	private tempId: string;

 	constructor( descriptor: NavbarDescriptor )
 	{
		this.tempId = ((Math.floor(Math.random() * (99999999 - 1000)) + 1000).toString() + Date.now()).toString();
		this.element = $( document.createElement( descriptor.tag ) );
		const header = $( document.createElement( 'div' ) );

		const container = $( document.createElement( 'div' ) );

		this.element.addClass( 'navbar' );

		for ( const i in descriptor.classes )
		{
			this.element.addClass( descriptor.classes[ i ] );
		}

		if ( descriptor.isFluid )
		{
			container.addClass( 'container-fluid' );
		}
		else
		{
			container.addClass( 'container' );
		}

		if ( descriptor.brand != null )
		{

	 		header.addClass( 'navbar-header' );
			 header.append( descriptor.brand );

			 container.append( header );
		}

		header.append(this.addMenuButton());

		this.tempDiv = $( document.createElement( 'div' ) );
		this.tempDiv.addClass( 'collapse navbar-collapse' );
		this.tempDiv.attr( 'id', this.tempId);

		this.tempUl = $( document.createElement( 'ul' ) );
		this.tempUl.addClass( 'nav navbar-nav' );
		this.tempDiv.append( this.tempUl );

		container.append( this.tempDiv );

		if ( descriptor.tag == 'footer')
		{
			this.tempDiv.attr( 'style', 'text-align: center;' );
		}

		this.element.append( container );

	}

	public addMenuPoint( descriptor: MenuPointDescriptor )
	{
		const tempLi = $( document.createElement( 'li' ) );
		const tempA = $( document.createElement( 'a' ) );

		if ( descriptor.content )
		{
			tempLi.append( descriptor.content );
			// XXX sollte in die .css ausgelagert werden
			tempLi.attr( 'style',  'padding-top:15px');
		}
		else
		{
			tempA.attr( 'href', descriptor.href);
			tempA.html( descriptor.title);
			tempLi.append( tempA );
		}

		this.tempUl.append( tempLi );
	}

	public addContent( descriptor: NavbarContentDescriptor )
	{
		this.tempDiv.append( descriptor.content );
	}

	public getElement() : HTMLElement
	{
		return this.element[ 0 ];
	}

	private addMenuButton()
	{
		const button = $( document.createElement( 'button' ) );
		button.attr( 'type', 'button');
		button.addClass( 'navbar-toggle collapsed' );
		button.attr( 'data-toggle', 'collapse');
		button.attr( 'data-target', '#' + this.tempId);

		let tempSpan = $( document.createElement( 'span' ) );
		tempSpan.addClass('sr-only');
		tempSpan.html( 'Menu' );

		button.append( tempSpan );

		tempSpan = $( document.createElement( 'span' ) );
		tempSpan.addClass( 'icon-bar' );
		button.append( tempSpan );

		tempSpan = $( document.createElement( 'span' ) );
		tempSpan.addClass( 'icon-bar' );
		button.append( tempSpan );

		tempSpan = $( document.createElement( 'span' ) );
		tempSpan.addClass( 'icon-bar' );
		button.append( tempSpan );

		return button;

	}

}
